import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetActivityByStatus } from 'domain/usecases/dashboard';

export class RemoteGetActivityByStatus implements GetActivityByStatus {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetActivityByStatus.Result>,
  ) {}

  async execute(
    params: GetActivityByStatus.Params,
  ): Promise<GetActivityByStatus.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.id} `,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
